<template>
	<section>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title is-size-5-mobile">
					{{ $t('Bid history') }}
					<span class="modal-prod-title">{{ _product.Bid.id }} - {{ _product.name | truncate(20, '…') }}</span>
				</p>
				<button class="delete" @click="$parent.close()"></button>
			</header>
			<section class="modal-card-body">
				<b-table :data="bidList" hoverable>
					<template slot-scope="props">
						<b-table-column sortable field="stamp" :label="$t('bid_time')">{{ props.row.stamp }}</b-table-column>
						<b-table-column field="price" :label="$t('Amount')">
							{{ toCurr(props.row.price, currency) }}
						</b-table-column>
						<b-table-column field="user" :label="$t('Bidder name')">{{
							props.row.User.UserPreference.name
						}}</b-table-column>
					</template>
					<template slot="footer">
						{{ $t('Opening price') }}:
						{{ $data._start_price | toCurrency(this, currency) }}
					</template>
					<template slot="bottom-left">
						<button class="button" type="button" @click="$parent.close()">
							{{ $t('Back') }}
						</button>
					</template>
					<template slot="empty">
						<h3 class="title">{{ $t('No results…') }}</h3>
					</template>
				</b-table>
			</section>
		</div>
	</section>
</template>
<script>
export default {
	data() {
		return {
			currency: localStorage.getItem('currency') || 'HUF',
			bidList: [],
			// eslint-disable-next-line vue/no-reserved-keys
			_start_price: 0,
		}
	},
	props: {
		_product: {
			required: true,
		},
	},

	methods: {
		toCurr(val, currency) {
			return this.$options.filters.toCurrency(val, this, currency)
		},
		getBids() {
			var _this = this
			_this.$http.get('/autobets/' + this._product.Bid.id).then((response) => {
				console.log('Bids:', response.data.bets)
				_this.bidList = response.data.bets
				if (_this.bidList.length > 0) {
					_this.$data._start_price = response.data.bets[response.data.bets.length - 1].price
				} else {
					_this.$data._start_price = _this._product.price
				}
				_this.loading = false
			})
		},
	},
	mounted() {
		this.getBids()
	},
}
</script>
<style scoped>
.modal-prod-title {
	float: right;
	margin-right: 1rem;
}

/*credit: https://stackoverflow.com/a/23899027/1943949*/

tr:nth-child(4n + 1) td,
tr:nth-child(4n + 2) td {
	background-color: hsl(0, 0%, 86%);
}

tr:nth-child(4n + 3) td,
tr:nth-child(4n + 4) td {
	background-color: white;
}
</style>
